import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { TipoItemInterface } from "app/module/tipo-item-interface";
import { ServicoInterface } from 'app/module/servico-interface';
import { ProdutoInterface } from 'app/module/produto-interface';

@Injectable({
	providedIn: 'root'
})
export class TipoItemService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public get(): Observable<TipoItemInterface> {
		return this.http.get<TipoItemInterface>(`${this.url}tipo-item`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getServico(): Observable<{ statusCode: number, message: string[], data: ServicoInterface[] }> {
		return this.http.get<{ statusCode: number, message: string[], data: ServicoInterface[] }>(`${this.url}servico}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getProduto(): Observable<{ statusCode: number, message: string[], data: ProdutoInterface[] }> {
		return this.http.get<{ statusCode: number, message: string[], data: ProdutoInterface[] }>(`${this.url}produto`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getServicoEmpresa(id): Observable<{ statusCode: number, message: string[], data: ServicoInterface[] }> {
		return this.http.get<{ statusCode: number, message: string[], data: ServicoInterface[] }>(`${this.url}servico/empresa/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getProdutoEmpresa(id): Observable<{ statusCode: number, message: string[], data: ProdutoInterface[] }> {
		return this.http.get<{ statusCode: number, message: string[], data: ProdutoInterface[] }>(`${this.url}produto/empresa/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
